import { Button, Card } from "semantic-ui-react"
import DiscountRibbon from "./SelectShop/DiscountRibbon"
import InfoIcon from "../../../images/info-outlined-icon.svg"
import { datePickerLocale } from "../../../v1/helpers/translationHelpers"
import { isDayDisabled } from "../../../shared_component/utils/dateHelpers"
import React, { useState } from "react"
import DatePicker from "react-datepicker"
import { getUpdatedCart } from "../../../v1/helpers/orderHelpers"
import { withRouter } from "react-router"
import { connect } from "react-redux"
import moment from "moment/moment"
import { updateCart } from "../../../v1/actions/user"
import LetsScheduleAppointmentModal from "./LetsScheduleAppointmentModal"
import { routerPaths } from "../../../v1/constants/paths"
import { CA } from "../../../v1/constants/states"

const SelectDate = ({ history, cart, user }) => {
  const [showLaterDate, setShowLaterDate] = useState(false)
  const [openLetsSchedule, setOpenLetsSchedule] = useState(false)
  const isOilChangeService = localStorage.getItem("isOilChangeService") === "true" || false

  const getNextThreeDays = () => {
    const today = new Date()
    const options = { month: "long", day: "numeric" }
    const days = []

    for (let i = 0; i < 3; i++) {
      const date = new Date()
      date.setDate(today.getDate() + i)

      const formattedDate = date.toLocaleDateString("en-US", options)
      if (i === 0) {
        days.push([`Today`, formattedDate, moment(date).set({ hour: "3", minute: "00" })])
      } else if (i === 1) {
        days.push([`Tomorrow`, formattedDate, moment(date).set({ hour: "3", minute: "00" })])
      } else {
        const weekday = date.toLocaleDateString("en-US", { weekday: "long" })
        days.push([weekday, formattedDate, moment(date).set({ hour: "3", minute: "00" })])
      }
    }

    return days
  }

  const onDateTimeSubmit = (date) => {
    sessionStorage.setItem("walkInDate", date)
    if (isOilChangeService || user.country === CA) {
      history.push(routerPaths.shopSelection)
    } else {
      history.push(routerPaths.selectService)
    }
  }

  if (showLaterDate) {
    return <LaterDate onDateTimeSubmit={onDateTimeSubmit} />
  }

  const onPickLaterDate = () => {
    if (cart.order_services.length > 0) {
      setShowLaterDate(true)
    } else {
      setOpenLetsSchedule(true)
    }
  }

  return (
    <Card className="service-card walk-in-select-date" raised={true}>
      <p className="appointment-title">When would you like to go?</p>

      <DiscountRibbon src={InfoIcon}>
        <p className="ribbon-text">
          <b>Tip:</b> Shops get busy during peak times like lunch. Try arriving mid-morning or
          mid-afternoon for a smoother visit.
        </p>
      </DiscountRibbon>

      <div className="appointment-list">
        {getNextThreeDays().map((day, i) => (
          <div key={i} className="appointment-option" onClick={() => onDateTimeSubmit(day[2])}>
            <b className="option-day">{day[0]}</b>, <span className="option-date">{day[1]}</span>
          </div>
        ))}
        <div className="appointment-option" onClick={onPickLaterDate}>
          <span>
            <b className="option-day">Pick a later date</b>
          </span>
        </div>
      </div>
      <LetsScheduleAppointmentModal
        open={openLetsSchedule}
        onClose={() => setOpenLetsSchedule(false)}
        continuePath={routerPaths.selectService}
      />
    </Card>
  )
}

const LaterDate = ({ onDateTimeSubmit }) => {
  const [selectedDate, setSelectedDate] = useState(null)

  return (
    <Card className="service-card walk-in-select-date" raised={true} style={{ gap: "24px" }}>
      <p className="appointment-title">Select a day for your walk-in</p>
      <DatePicker
        inline
        selected={selectedDate}
        onChange={(date) => {
          setSelectedDate(date)
        }}
        locale={datePickerLocale()}
        filterDate={isDayDisabled}
        minDate={new Date()}
      />
      <div className="action_button">
        <Button
          fluid
          disabled={!selectedDate}
          onClick={() => {
            onDateTimeSubmit(moment(selectedDate).set({ hour: "3", minute: "00" }))
          }}
          className="primary-button"
        >
          Confirm & continue
        </Button>
      </div>
    </Card>
  )
}

function mapStateToProps(state, props) {
  let user = state.user
  let activeVehicle = user.vehicles && user.vehicles.find((v) => v.id == user.activeVehicleId)
  let cart

  const order =
    activeVehicle &&
    activeVehicle.id &&
    (user.active_orders || []).find((o) => o.vehicle_id === activeVehicle.id)
  let updatedCartData = getUpdatedCart(user, order, props)

  if (updatedCartData) {
    cart = updatedCartData.cart
  } else {
    cart = user.active_carts && user.active_carts.find((c) => c.vehicle_id == user.activeVehicleId)
  }
  return {
    user,
    activeVehicle,
    cart
  }
}
export default withRouter(
  connect(mapStateToProps, {
    updateCart
  })(SelectDate)
)
